<div class="modal-backdrop in"></div>

<div class="modal">
  <div class="modal-dialog glu-dialog dialog-{{type}} {{modalClass}}">
    <form class="modal-content">
      {{#if title}}
        <div class="modal-header">
          {{icon name=closeIcon text="Close" action="close" className="close"}}

          <h4 class="modal-title" id="modal-title">
            {{#if dialogIcon}}{{icon dialogIcon}}{{/if}}
            <span class="title-value">{{title}}</span>
          </h4>
        </div>
      {{/if}}

      <div class="modal-body" id="modal-body">
        <p>{{message}}</p>
      </div>

      <div class="modal-footer">
        {{#if buttons}}
          {{#each buttons}}
            <button type="button" class="btn {{ className }} popbox-btn{{@index}}" data-key="{{@index}}">{{text}}</button>
          {{/each}}
        {{/if}}
      </div>
    </form>
  </div>
</div>
